<template>
  <div v-if="options && options.data" :style="'padding:' + options.data.pageCss.page_css_padding +
    ';margin:' + options.data.pageCss.page_css_margin +
    ';border-radius:' + options.data.pageCss.page_css_radius +
    'px;background-color:' + options.data.pageCss.textBgc + ';' + options.data.pageCss.myCss" class="form">
    <div class="form_item">
      <p class="form_title">
        <span>{{ options.form_title || '表单' }}</span>
      </p>

      <component :style="'margin-bottom:' + options.data.pageCss.page_css_interval + 'px;'"
        v-for="(item, index) in options.data.menuArr" :key="index" :is="item.type" :index="index"></component>
      <p>
        <span @click="beForeJoin()" class="qd" :class="{ disabled_join: !login }">{{ options.button_text || '提交' }}</span>
      </p>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { createForm } from "@/api/meetApi.js";
import wx from 'weixin-js-sdk';
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["index", 'meeting_data'],
  data() {
    return {
      formID: '',
      form: {},
      login: true,
    }
  },
  computed: {
    ...mapGetters(["formwork"]),
    ...mapGetters(["okForm"]),
    ...mapGetters(["workPlace"]),
    options() {
      let options = this.okForm[this.index]
        ? this.okForm[this.index].options
        : { data: JSON.parse(JSON.stringify(this.workPlace.formBox.data)) }

      this.formID = this.okForm[this.index] ? this.okForm[this.index].id : ''
      console.log(this.formID)

      // 判断本地是否有上一次签到信息，有本场的禁用签到按钮
      // 注意updated_at会在每次后台编辑表单后重置，会被认为是新表单
      let historyData = JSON.parse(localStorage.getItem('joinUs')) || JSON.parse(this.getCookie('cookie_joinUs')) || JSON.parse(localStorage.getItem('login_base')) || JSON.parse(this.getCookie('cookie_login_base'))


      if (historyData && historyData.meeting_id == this.meeting_data.id) {

        if (options.data.pageCss && !options.is_again && options.data.pageCss.out_url) {
          // 1.不允许重复签到  // 2.out_url有值，则跳转到外部链接
          window.location.href = options.data.pageCss.out_url
          return options
        }

        if (options.data.pageCss && !options.is_again && !options.data.pageCss.out_url) {

          // 1.不允许重复签到 且历史表单id相等，禁用签到按钮
          if (historyData.id == this.formID) {
            this.login = false
          } else {
            this.login = true
          }

          let baseData = this.mergeDeep(options.data.menuArr, historyData.options.data.menuArr)
          this.$store.state.formwork.formwork = baseData
          return options
        }

        // 1.允许重复签到  
        this.login = true
        let baseData = this.mergeDeep(options.data.menuArr, historyData.options.data.menuArr)
        this.$store.state.formwork.formwork = baseData

      } else {
        this.$store.state.formwork.formwork = options.data.menuArr
        this.login = true
      }
      return options
    },
  },
  created() {
    const requireComponent1 = require.context(
      "@/components/formwork",
      false,
      /\.vue$/
    );
    requireComponent1.keys().forEach(fileName => {
      let config1 = requireComponent1(fileName);
      let fimeNameChange1 = fileName.replace(/^\.\//, "").replace(/\.\w+$/, "");
      let componentName1 =
        fimeNameChange1.charAt(0).toLowerCase() +
        fimeNameChange1.slice(1) +
        "Work";
      Vue.component(componentName1, config1.default || config1);
    });

    // 判断本地是否有上一次签到信息，有本场的禁用签到按钮
    // let historyData = JSON.parse(localStorage.getItem('joinUs'))
    // if (historyData && historyData.meeting_id == this.meeting_data.id) {
    //   this.login = false
    //   this.$store.state.formwork.formwork = historyData.options.data.menuArr
    // }

    if (this.$route.query.view_id == 106) {
      this.WX_LOGIN()
    }

  },
  methods: {
    mergeDeep(obj1, obj2) {

      // 如果 obj1 或 obj2 不是对象，直接返回 obj2 覆盖 obj1
      if (typeof obj1 !== 'object' || obj1 === null) return obj2;
      if (typeof obj2 !== 'object' || obj2 === null) return obj1;

      let base1 = JSON.parse(JSON.stringify(obj1));
      let base2 = JSON.parse(JSON.stringify(obj2));
      console.log(base1)
      console.log(base2)

      base1.forEach((item, index) => {
        base2.forEach((item_J, index_J) => {
          if (item.options.label == item_J.options.label) {
            if (item.options.typeof != 'article') {
              item.options.value = item_J.options.value || '';
            }
            base2.splice(index_J, 1)
          }
        })
      })


      return base1;
    },
    beForeJoin() {
      if (this.options.positioning) {
        this.getLocation()
      } else {
        this.join()
      }
    },

    async join(title) {
      console.log(this.formwork)
      if (!this.login) {
        return this.$message.error('您已提交过表单，感谢您的支持！')
      }

      try {
        this.formwork.forEach(item => {
          if (item.options.require && !item.options.value||item.options.require && !item.options.value[0]) {
            let alertTxt = item.options.requireMsg ? item.options.requireMsg : '请填写必填项！';
            throw new Error(alertTxt);
          }

          if (item.options.reg) {
            // item.options.reg.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& 表示整个匹配的字符串
            let regex = new RegExp(item.options.reg);
            if (!regex.test(item.options.value)) {
              let alertTxt = item.options.regMsg ? item.options.regMsg : item.options.label + '格式不正确！';
              throw new Error(alertTxt);
            }
          }
        })

        let sendData = JSON.parse(JSON.stringify(this.okForm[this.index]));
        sendData.options.data.menuArr = this.formwork
        sendData.meeting_id = this.meeting_data.id
        let data = await createForm(sendData)
        localStorage.setItem('joinUs', JSON.stringify(sendData))
        this.setCookie('cookie_joinUs', JSON.stringify(sendData), 7)
        // this.login = false 
        this.$message.success('提交成功！');
        if (this.options.data.pageCss && this.options.data.pageCss.out_url) {
          setTimeout(() => {
            window.location.href = this.options.data.pageCss.out_url
          }, 800)
        } else {
          if (!this.options.is_again) {
            this.login = false
          }
        }
      } catch (e) {
        console.log(e)
        this.$message.error(e.message || '提交失败！')
      }
    },
    getLocation() {

      var userAgent = navigator.userAgent.toLowerCase();
      // 判断是否在微信中打开
      if (userAgent.indexOf('micromessenger') !== -1) {
      } else {
        return alert('请在手机微信中打开此页面')
      }
      let _this = this

      wx.ready(function () {
        wx.getLocation({
          type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          altitude: true,
          success: function (res) {
            console.log(res)
            var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            var speed = res.speed; // 速度，以米/每秒计
            var accuracy = res.accuracy; // 位置精度   
            var jiali_lat = _this.options.latitude;
            var jiali_long = _this.options.longitude;
            _this.getDistance(jiali_lat, jiali_long, latitude, longitude)
          },
          fail: function (xhr) {
            console.log(xhr)
            if (xhr.errMsg && xhr.errMsg.indexOf('fail')) {
              alert('您未开启定位，请开启定位服务后重试!');
            }
          }
        });
      })
    },
    getDistance(lat1, lng1, lat2, lng2) {
      let _this = this
      lat1 = lat1 || 0;
      lng1 = lng1 || 0;
      lat2 = lat2 || 0;
      lng2 = lng2 || 0;
      var rad1 = lat1 * Math.PI / 180.0;
      var rad2 = lat2 * Math.PI / 180.0;
      var a = rad1 - rad2;
      var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
      var r = 6378137;
      var distance = r * 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(rad1) * Math.cos(rad2) * Math.pow(Math.sin(b / 2), 2)));
      console.log('distance', distance)
      if (distance > 200) {
        alert('您当前不在会场，请前往现场签到!');
        return;
      } else {
        _this.join()
      }
    },
  },

}
</script>

<style lang="less" scoped>
.clearItem_solt {
  opacity: 1;
  position: absolute;
  right: 0;
  top: 0;
  width: 14px;
  z-index: 99;
}

.form {
  // width: 100%;
  max-height: 70%;
  margin: auto;
  background-color: #fff;
  padding: 20px;
  position: relative;
  display: flex;
  top: 10%;
}

.form_title {
  font-weight: 600;
  font-size: 20px;
  color: #222222;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  justify-content: center;
}

.form_item {
  flex: 1;
  overflow: auto;
}

.qd {
  display: inline-block;
  height: 42px;
  line-height: 42px;
  width: 100%;
  background-color: #4988fd;
  border-radius: 24px;
  text-align: center;
  color: white;
  margin-top: 5px;
}

.disabled_join {
  background-color: #d9d9d9;
  cursor: not-allowed;
}

.close {
  position: absolute;
  width: 40px;
  height: 40px;
  left: 50%;
  transform: translateX(-50%);
  bottom: -50px;
}

.draggableBox {
  position: relative;
}

.draggableBox_poa {
  position: absolute;
  width: 100%;
  height: 100%;
  // border: 1px solid #1478f1;
  z-index: 99;
  left: 0%;
  opacity: 0.1;
  top: 0%;
  border-radius: 2px;
}

.draggableBox_poaED {
  background-color: #1478f1;
}
</style>
<style>
.login .ant-form-item-control-wrapper {
  padding-bottom: 8px;
}

.login .ant-form-horizontal {
  margin-bottom: 8px;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  width: 6px;
  background: rgba(#101f1c, 0.1);
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.5);
  background-clip: padding-box;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
  transition: background-color 0.3s;
  cursor: pointer;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144, 147, 153, 0.3);
}

.form_item .video_baseFormBox {
  position: relative;
}
</style>